import { Component, effect, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChildNotificationInterface, ItemCommunicationService, ParentNotificationInterface, ParentTriggerInterface } from 'src/app/features/items/components/items-module/items-tab/services/item-communication.service';
import { Items } from 'tilby-models';
import { ItemChannelsFormGroups } from './item-channels.model';
import { ItemChannelsFormService } from './item-channels-form.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PriceListInterface } from 'src/app/features/items/utils/item.interface';
import { TilbyCurrencyPipe } from '@tilby/tilby-ui-lib/pipes/tilby-currency';
import { TruncatedTextDirective } from 'src/app/directives/truncated-text.directive';
import { MatTooltipModule } from '@angular/material/tooltip';

import {
  ItemDataCatalogService,
  ItemDataOperationsService,
} from 'src/app/features/items';

@Component({
  selector: 'app-item-channels',
  standalone: true,
  imports: [ MatFormFieldModule, ReactiveFormsModule,
    TranslateModule, FormsModule, CommonModule,
    MatInputModule, MatSelectModule, MatSlideToggleModule,
    TruncatedTextDirective, MatTooltipModule
  ],
  templateUrl: './item-channels.component.html',
  styleUrl: './item-channels.component.scss'
})
export class ItemChannelsComponent implements OnInit {

  private readonly itemCommunicationService = inject(ItemCommunicationService);
  readonly itemChannelsFormService = inject(ItemChannelsFormService);
  private readonly itemDataOperationsService = inject(ItemDataOperationsService);
  private readonly tilbyCurrencyPipe = inject(TilbyCurrencyPipe);
  private readonly itemDataCatalogService = inject(ItemDataCatalogService);

  @Input() item!: Items;

  itemChannelsForm!: FormGroup<ItemChannelsFormGroups>;

  fallbackImageUrl: string = 'assets/images/channels/pos.png';  
  priceList: Array<PriceListInterface> = [];
  priceValue!: Record<string, number>;

  isDataListReady = this.itemDataCatalogService.isReady;
  itemChannelsFormReady = this.itemChannelsFormService.itemChannelsFormReady;

  constructor() {
    this.readData();

    effect(() => {
      if(this.isDataListReady()) {
        this.itemChannelsForm = this.itemChannelsFormService.createForm(this.item);
      }
    }, { allowSignalWrites: true })

    effect(() => {
      // Listener per eseguire operazioni richieste dal parent
      const trigger = this.itemCommunicationService.parentTrigger();
      if(trigger?.child === 'channels' || trigger?.child === 'all') {
        this.handleParentTrigger(trigger);
      }
    })

    effect(() => {
      // Listener per leggere notifiche inviate dal parent
      const notification = this.itemCommunicationService.parentNotifier();
      if (notification?.child === 'channels') {
        this.handleParentNotification(notification);
      }
    })
  }

  handleParentTrigger(message: ParentTriggerInterface) {
    if(message.trigger === 'tabActivated') {
      this.requestGeneralFormData();
    }
    
    if(message.trigger === 'cancel') {
      this.itemChannelsFormService.resetFormValues(this.item);
    }
  }

  requestGeneralFormData() {
    const fieldsList = this.priceList.map(({priceFieldName}) => priceFieldName);
    setTimeout(() => {
      this.itemCommunicationService.createParentTrigger('requestGeneralData', 'general', 'channels', 
        { fieldsList: fieldsList })
    })
  }

  handleParentNotification(message: ParentNotificationInterface) {
    if(message.notification === 'generalData') {
      this.priceValue = message.params;
    }
  }

  ngOnInit(): void {
  }
  
  readData() {
    this.priceList = this.itemDataOperationsService.getPriceLists();
  }

  sendNotificationToParent(notification: ChildNotificationInterface) {
    Promise.resolve().then(() => {
      this.itemCommunicationService.notifyParent(notification);
    });
  }

  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    if (imgElement) {
      imgElement.src = this.fallbackImageUrl;
    }
  }

  getItemPriceString(priceFieldName: string) {
    const price = this.priceValue?.[priceFieldName as keyof Items];
    return price ? `(${this.tilbyCurrencyPipe.transform(price)})` : '';
  }
}
